<template>
  <b-card class="client-register-system-edit-page">
    <b-modal
        ref="consulting-rights-modal"
        id="consulting-rights-modal"
        modal-class="modal-primary consulting-rights-modal "
        title="Consultar direitos"
        ok-title="Adicionar"
        centered
        size="xl"
        no-close-on-backdrop
      >
      <div class="d-block">
        <consulting-client-rights :currentFilter="form.filters"></consulting-client-rights>
      </div>
    </b-modal>
    <b-tabs>
        <b-tab title="Configurações">
          <b-row>
            <b-col md="12">
              <div class="form-label-group">
                <label for="origin-list">Origem</label>
                <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                    :disabled="!newRegister"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>

            <b-col md="12"></b-col>
            <b-col md="12">
              <div class="form-label-group">
                <b-button
                  variant="flat-primary"
                  class="btn-icon rounded-circle"
                  v-b-modal.consulting-rights-modal
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
                <b-form-textarea
                  id="filters"
                  placeholder="Filtros"
                  rows="6"
                  v-model="form.filters"
                />
                <label for="filters">Filtros</label>
              </div>
            </b-col>
            <b-col md="12"></b-col>

            <b-col md="3">
              <div class="form-label-group">
                <label for="nl-list">Numero Lógico</label>
                <b-form-group label="Numero Lógico" label-for="nl-list">
                  <v-select
                    id="nl-list"
                    v-model="form.logicalNumber"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="logicalNumber"
                  >
                    <!-- :disabled="!newRegister" -->
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>

            <b-col md="3">
              <div class="form-label-group">
                <label for="country-list">País</label>
                <b-form-group label="País" label-for="country-list">
                  <v-select
                    id="country-list"
                    v-model="form.country"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="country"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>

            <b-col md="3">
              <div class="form-label-group">
                <label for="wdma-route-list">Wdma Route</label>
                <b-form-group label="Wdma Route" label-for="wdma-route-list">
                  <v-select
                    id="wdma-route-list"
                    v-model="form.wdma_route"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="country"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>

            <b-col md="4">
              <div class="form-label-group">
                <label for="profile-list">Perfil</label>
                <b-form-group label="Perfil" label-for="profile-list">
                  <v-select
                    id="profile-list"
                    v-model="form.profile"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="profile"
                    :reduce="option => option.id"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <label for="nl-list">Assinatura</label>
                <b-form-group label="Assinatura" label-for="nl-list">
                  <v-select
                    id="nl-list"
                    v-model="form.signature"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="clientSignatures"
                  >
                    <!-- :disabled="!newRegister" -->
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>

            <b-col md="12"></b-col>

            <!-- <b-col md="6">
              <div class="form-label-group">
                <label for="sendmail-content-list">Envio de email por conteúdo</label>
                <b-form-group
                  label="Envio de email por conteúdo"
                  label-for="sendmail-content-list"
                >
                  <v-select
                    id="sendmail-content-list"
                    v-model="form.sendmail_content"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="content"
                    multiple
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col>
            <b-col md="6">
              <div class="form-label-group">
                <b-form-group label="Notificação Push" label-for="push_notification">
                  <v-select
                    id="push_notification"
                    v-model="form.push_notification"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="subject"
                  >
                  </v-select>
                </b-form-group>
              </div>
            </b-col> -->
            <b-col md="6">
              <div class="form-label-group">
                <b-form-input
                  id="token"
                  placeholder="Token"
                  v-model="form.token"
                />
                <label for="token">Token</label>
              </div>
            </b-col>
            <b-col md="2">
              <div class="form-label-group">
                <b-form-input
                  id="available_questions"
                  placeholder="Perguntas restante"
                  v-model="form.available_questions"
                />
                <label for="available_questions">Perguntas restante</label>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-label-group">
                <label for="newPassword">Nova Senha</label>
                <b-form-input
                  id="newPassword"
                  placeholder="Nova Senha"
                  v-model="form.newPassword"
                  type="password"
                />
              </div>
            </b-col>

            <b-col md="12"><hr></b-col>
            <b-col md="12" style="margin-bottom: 10px"><h4>Acceptor config</h4></b-col>
            <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  id="cma_pwd"
                  placeholder="cma_pwd"
                  v-model="form.cma_pwd"
                />
                <label for="cma_pwd">Senha de acesso wdma (cma_pwd)</label>
              </div>
            </b-col>
            <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  id="customer_id"
                  placeholder="Customer Id"
                  v-model="form.customer_id"
                />
                <label for="customer_id">Customer ID</label>
              </div>
            </b-col>
            <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  id="logical_user"
                  placeholder="Usuário logico"
                  v-model="form.logical_user"
                />
                <label for="logical_user">Usuário logico</label>
              </div>
            </b-col>
            <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  id="service"
                  placeholder="Acceptor Domain"
                  v-model="form.service"
                />
                <label for="service">Acceptor Domain</label>
              </div>
            </b-col>
            <b-col md="12"><hr></b-col>
            
            <b-col md="12">
              <div class="form-label-group">
                <label for="url_token">Esqueci a Senha</label>
                <b-form-input
                  id="url_token"
                  placeholder="Esqueci a senha URL"
                  v-model="form.url_token"
                  disabled
                />
              </div>
            </b-col>

            <b-col md="6">
              <div class="form-label-group">
                <b-form-input
                  id="dt_first_access"
                  placeholder="Data Primeiro Acesso"
                  v-model="form.dt_first_access"
                  disabled
                />
                <label for="dt_first_access">Data Primeiro Acesso</label>
              </div>
            </b-col>
            <b-col md="6">
              <div class="form-label-group">
                <b-form-input
                  id="dt_last_access"
                  placeholder="Data Ultimo acesso"
                  v-model="form.dt_last_access"
                  disabled
                />
                <label for="dt_last_access">Data Ultimo acesso</label>
              </div>
            </b-col>
            
            <b-col md="12" class="mb-1"><hr /></b-col>
            <b-col md="12"></b-col>
            <b-col md="2">
              <div class="form-label-group">
                <b-form-input
                  id="siga_login_inicio"
                  placeholder="Siga login inicio"
                  v-model="form.siga_login_inicio"
                />
                <label for="siga_login_inicio">Siga login inicio</label>
              </div>
            </b-col>
            <b-col md="2">
              <div class="form-label-group">
                <b-form-input
                  id="siga_login_termino"
                  placeholder="Siga login termino"
                  v-model="form.siga_login_termino"
                />
                <label for="siga_login_termino">Siga login termino</label>
              </div>
            </b-col>
            <b-col md="2">
              <div class="form-label-group">
                <b-form-input
                  id="siga_login_atualizacao"
                  placeholder="Siga login atualização"
                  v-model="form.siga_login_atualizacao"
                />
                <label for="siga_login_atualizacao">Siga login atualização</label>
              </div>
            </b-col>
            <b-col md="2">
              <div class="form-label-group">
                <b-form-input
                  id="siga_posicao"
                  placeholder="Siga posição"
                  v-model="form.siga_posicao"
                />
                <label for="siga_posicao">Siga posição</label>
              </div>
            </b-col>
            <b-col md="2">
              <div class="form-label-group">
                <b-form-input
                  id="amount_access"
                  placeholder="Accesso simultâneo"
                  v-model="form.amount_access"
                />
                <label for="amount_access">Accesso simultâneo</label>
              </div>
            </b-col>

            
            <b-col md="12" class="mb-1"><hr /></b-col>
            <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  id="name"
                  placeholder="Nome"
                  v-model="form.name"
                />
                <label for="name">Nome</label>
              </div>
            </b-col>
            <b-col md="3">
              <div class="form-label-group">
                <b-form-input
                  id="email"
                  placeholder="Email"
                  v-model="form.email"
                />
                <label for="email">Email</label>
              </div>
            </b-col>
            <!-- <b-col md="6">
              <div class="form-label-group">
                <b-form-group label="Grupos" label-for="groups">
                  <v-select
                    id="groups"
                    v-model="form.groups"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="clientGroup"
                  >
                  </v-select>
                </b-form-group>
              </div>
            </b-col> -->
            <b-col md="12"><hr /></b-col>
            
            <b-col md="12">
              <b-form-group>
                <b-form-checkbox id="active" name="active" v-model="form.active">
                  Ativo
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <b-form-checkbox id="authEmail" name="authEmail" v-model="form.authEmail">
                  Dupla autenticação por email
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <b-form-checkbox id="authQRCode" name="authQRCode" v-model="form.authQRCode">
                  Dupla autenticação por QR Code
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <b-form-checkbox id="hasEmailConfirmed" name="hasEmailConfirmed" v-model="form.hasEmailConfirmed">
                  Email confirmado
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <b-form-checkbox id="enableUpdateFromSiga" name="enableUpdateFromSiga" v-model="form.enableUpdateFromSiga">
                  Habilitar atualização do sigaweb
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <b-form-checkbox id="user_tester" name="user_tester" v-model="form.user_tester">
                  Usuário Tester
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
                @click="onSubmit"
              >
                OK
              </b-button>
              <b-button variant="danger" class="mr-1" @click="onClose">
                Cancelar
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Email/Push">
          <div>
            <b-card>
              <h4>Bloquear Notificação</h4>
              <b-row>
                <b-col md="12" class="flex mt-1">
                  Não quero receber e-mail: <b-form-checkbox v-model="form.notSendEmailNotification" switch class="ml-1"/>
                </b-col>
                <b-col md="12" class="flex mt-1">
                  Não quero receber push: <b-form-checkbox v-model="form.notSendPushNotification" switch class="ml-1"/>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div>
            <b-card>
              <app-collapse
                accordion
                type="margin"
                not-arrow
              >
                <app-collapse-item title="" v-for="(item, index) in form.notification_config" :key="index">
                  <div slot="header" class="d-flex
                    justify-content-between
                    align-items-center">
                    {{item.subject.name}}
                  </div>
                  <div>
                    <b-row>
                      <b-col md="10"><b>Conteúdo</b></b-col>
                      <b-col md="1"><b>Email</b></b-col>
                      <b-col md="1"><b>Push</b></b-col>
                    </b-row>
                    <hr>
                    <b-row v-for="(dataC, index) in item.data" :key="index" class="config-email-row">
                      <b-col md="10">{{dataC.content.namePtBr}}</b-col>
                      <b-col md="1"><b-form-checkbox v-model="dataC.email" switch /></b-col>
                      <b-col md="1"><b-form-checkbox v-model="dataC.push" switch /></b-col>
                    </b-row>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </b-card>
          </div>
        </b-tab>
        <b-tab title="Enviar email">
          <b-button
            size="sm"
            variant="outline-primary mr-1"
            @click="sendFirstAccessEmail"
          >
            <span class="ml-25 align-middle">Primeiro acesso</span>
            <feather-icon icon="SendIcon" size="12"/>
          </b-button>

        </b-tab>
    </b-tabs>
  
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BFormTextarea,
  VBModal,
  BTabs,
  BTab,
  // BListGroup,
  // BListGroupItem,
  // BCardText
} from "bootstrap-vue";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import ConsultingClientRights from './ConsultingClientRights.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { formatDate } from "@core/utils/filter";
import clientService from '@/providers/clientService';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      form: {
        _id: "",
        name: "",
        email: "",
        active: false,
        blocked: false,
        blocked_reason: "",
        password: "",
        password_validate: null,
        token: "",
        url_token: "",
        device_id: "",
        filters: "",
        dt_first_access: null,
        dt_last_access: null,
        available_questions: null,
        logical_user: "",
        cma_pwd: "",
        customer_id: "",
        service: "",
        siga_login_inicio: "",
        siga_login_termino: "",
        siga_login_atualizacao: "",
        siga_posicao: null,
        origin: null,
        push_notification: [],
        sendmail_content: [],
        country: null,
        wdma_route: null,
        logicalNumber: null,
        newPassword: "",
        groups: [],
        profile: null,
        authEmail: false,
        authQRCode:  false,
        hasEmailConfirmed: false,
        enableUpdateFromSiga: true,
        notSendEmailNotification: false,
        notSendPushNotification: false,
        notification_config: [],
        amount_access: 1,
        authentication: [],
        user_tester: false
      },
      origins: [],
      country: [],
      logicalNumber: [],
      subject: [],
      content: [],
      clientGroup: [],
      profile: [],
      clientSignatures: [],
      newRegister: false,
      services: [
        'sfplrt',
        'sfpldt'
      ],
    };
  },
  props: {
    clientId: {
      type: String,
      default: ""
    }
  },
  created() {
    console.log('created form: ',this.form);
    this.loadData();
  },
  computed: {},
  watch: {
    "form.origin"(val) {
      if (val) {
        this.subject = [];
        this.content = [];
        this.loadDataByOrigin();
      }
    },
  },
  methods: {
    sendFirstAccessEmail() {
      messageDialogHelper.displayConfirmMessage(
        "Envio de email",
        "Confirmar envio de primeiro acesso ao cliente?",
        () => {
          const form = {
            _id: this.form._id,
            client_id: this.clientId
          };
          clientService.sendFirstAccessEmail(form, new URLSearchParams())
            .then(() => {
              messagesNotifyHelper.successNotify('Primeiro acesso', 'Email enviado com sucesso');
            }).catch(err => console.log(err));
        }
      );
      
    },
    formatCurrDate(dt) {
      return formatDate(dt, {
        dateStyle: "short",
        timeStyle: "medium",
      });
    },
    clearAllAuth() {
      messageDialogHelper.displayConfirmMessage(
        "Limpar Autenticaçãao",
        "Deseja limpar todos os tokens?",
        () => {
          this.form.authentication = [];
        });
    },
    clearAuth(data) {
      messageDialogHelper.displayConfirmMessage(
        "Limpar Autenticaçãao",
        "Deseja limpar token selecionado?",
        () => {
          const index = this.form.authentication.findIndex(item => item.token == data.token);
          if (index >= 0) {
            this.form.authentication.splice(index, 1);
          }
        });
    },
    onSubmit() {
      this.$emit("submit", this.form);
    },
    onClose() {
      this.$emit("close");
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
        dropdownService.getAllLogicalNumber(new URLSearchParams()),
      ])
        .then((res) => {
          this.origins = res[0];
          this.country = res[1];
          this.wdma_route = res[1];
          this.logicalNumber = res[2];
          console.log(this.form);
          if (this.form.origin) {
            this.loadDataByOrigin();
          }
        })
        .catch((err) => console.log(err));
    },
    loadDataByOrigin() {
      const params = new URLSearchParams();
      params.append("origins", this.form.origin.id);
      Promise.all([
        dropdownService.getContent(params),
        dropdownService.getAllSubjects(params),
        dropdownService.getClientGroup(params),
        dropdownService.getAllClientProfile(params),
        dropdownService.getClientSignatures(params),
      ])
        .then((res) => {
          this.content = res[0];
          this.subject = res[1];
          this.clientGroup = res[2];
          this.profile = res[3];
          this.clientSignatures = res[4];
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BFormTextarea,
    vSelect,
    ConsultingClientRights,
    BTabs,
    BTab,
    AppCollapse,
    AppCollapseItem,
    // BListGroup,
    // BListGroupItem,
    // BCardText
  },
};
</script>

<style lang="scss">
  .client-register-system-edit-page .tab-content > .active {
    display: block;
  }
  .config-email-row {
    margin-bottom: 0.4rem;
  }
  .token-list .token {
    width: 99% !important;
  }
</style>